let initState = {
    loading: false,
    sync_success_visible: false,
    sync_failure_visible: false,
}

const reducer = (state = initState, action) => {
    switch (action.type) {
        case 'SYNC_ORDERS':
            return { ...state, loading: true }
        case 'SYNC_ORDERS_SUCCESS':
            return { ...state, sync_result: action.json.data.data, loading: false, sync_success_visible: true, code: action.json.data.code}
        case 'SYNC_ORDERS_FAILURE':
            return { ...state, failure: true, loading: false }
        case 'ON_OK_SYNC':
            return { ...state, sync_success_visible: false, sync_failure_visible: false }
        case 'SYNC_LOADING_TRUE': 
            return { ...state, loading: true }
        case 'SYNC_LOADING_FALSE': 
            return { ...state, loading: false }
        default:
            return state
    }
}
export default reducer



// WEBPACK FOOTER //
// ./src/reducers/syncReducer.js